import React from 'react';

export const DadosBeneficio = ({ dadosIniciais }) => {
  return (
    <div className="mt-3 ">
      <h2>
        <strong>Dados do benefício atual</strong>
      </h2>
      <div className="row mb-4 mt-4">
        <div className="col-12 col-md-12 col-lg-4 mt-2">
          <p className="text-orange fw-bold ts-20">Tipo de benefício</p>
          <p className="text-muted fw-bold ts-18 mt-2">
            {dadosIniciais.tipoBeneficio}
          </p>
        </div>
        <div className="col-12 col-md-12 col-lg-4 mt-2">
          <p className="text-orange fw-bold ts-20">Forma de recebimento</p>
          <p className="text-muted fw-bold ts-18 mt-2">
            {dadosIniciais.formaRecebimento}
          </p>
        </div>
        {dadosIniciais.pessoasGrupoFamiliar > 1 && (
          <div className="col-12 col-md-12 col-lg-4 mt-2">
            <p className="text-orange fw-bold ts-20">
              Qtd. pessoas por grupo familiar
            </p>
            <p className="text-muted fw-bold ts-18 mt-2">
              {dadosIniciais.pessoasGrupoFamiliar}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
